module.exports = __webpack_public_path__ + "assets/images/chroma-animation_ae32c07a2ea31c62f44db0d7a33457be.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-four/chroma-animation.gif
// module id = 277
// module chunks = 0